import firebase from "firebase/compat/app";
/**
 * 日付型からFirebase.FirestoreのTimestamp型へ変換を行います
 */
export const ConvertTimeStampFromDate = (date: Date) => {
  return firebase.firestore.Timestamp.fromDate(date);
};
